<template>
  <div ref="inputbox">
    <b-form-datepicker
      v-model="date"
      class="sr__input sr__datepicker"
      :class="{'sr__input--invalid': !this.dateValid}"
      :disabled="disable"
      placeholder="請選擇日期"
    >
    </b-form-datepicker>

    <b-form-invalid-feedback :state="dateValid">
      {{dateInvalidMsg}}
    </b-form-invalid-feedback>

    <b-form-timepicker
      v-model="time"
      class="sr__input sr__datepicker"
      :class="{'sr__input--invalid': !this.timeValid}"
      :disabled="disable"
      placeholder="請選擇時間"
    >
    </b-form-timepicker>

    <b-form-invalid-feedback :state="timeValid">
      {{timeInvalidMsg}}
    </b-form-invalid-feedback>
  </div>
</template>

<script>
export default {
  name: 'DateItem',
  props: {
    field: Object,
    disable: Boolean
  },
  data () {
    return {
      date: '',
      time: '',
      dateValid: true,
      dateInvalidMsg: '',
      timeValid: true,
      timeInvalidMsg: ''
    }
  },
  watch: {
    date () {
      this.checkDateValueIsValid()
      this.field.value = this.getDateTimeString()
    },
    time () {
      this.checkTimeValueIsValid()
      this.field.value = this.getDateTimeString()
    }
  },
  methods: {
    isDateValid (dateStr) {
      return !isNaN(new Date(dateStr))
    },
    getDateTimeString () {
      return `${this.date} ${this.time}`
    },
    checkDateValueIsValid (uiNotify = true) {
      if (this._isDestroyed) {
        this.dateValid = true
        this.dateInvalidMsg = ''
        return true
      }

      if (!this.isDateValid(this.date)) {
        if (!uiNotify) {
          return false
        }

        this.dateValid = false
        this.dateInvalidMsg = '欄位必填'
      } else {
        this.dateValid = true
        this.dateInvalidMsg = ''
      }

      return this.dateValid
    },
    checkTimeValueIsValid (uiNotify = true) {
      if (this._isDestroyed) {
        this.timeValid = true
        this.timeInvalidMsg = ''
        return true
      }

      if (!this.time) {
        if (!uiNotify) {
          return false
        }

        this.timeValid = false
        this.timeInvalidMsg = '欄位必填'
      } else {
        this.timeValid = true
        this.timeInvalidMsg = ''
      }

      return this.timeValid
    }
  },
  created () {
    if (this.field.value !== '') {
      this.date = this.$toolDoc.getDateString(this.field.value, { type: 'date', ce: true })
      this.time = this.$toolDoc.getTimeString(this.field.value)
    }
  },
  mounted () {
    var top = this.$refs.inputbox.getBoundingClientRect().top

    this.$store.dispatch('pushValidateInfo', {
      id: `date_${this._uid}`,
      top: () => { return top },
      checkValueIsValid: this.checkDateValueIsValid
    })

    this.$store.dispatch('pushValidateInfo', {
      id: `time_${this._uid}`,
      top: () => { return top },
      checkValueIsValid: this.checkTimeValueIsValid
    })
  }

}
</script>
